<div class="[ relative container container-max-width-3xl stack ]">
  @if (role$ | async; as role) {
    @switch (role) {
      <!-- Student registration -->
      @case ('student') {
        <h1 class="[ headline-large text-center ]" data-cy="form-header">Registreer als leerling</h1>
        @if (isMaintenanceMode$ | async) {
          <campus-maintenance-mode
            [statusPageUrl]="statusPageUrl"
          ></campus-maintenance-mode>
        } @else {
          <dcr-animated-kai
            #kai
            src="assets/rive/kai_state_machine.riv"
            autoplay
            track-lookat
            react-to-click
            class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
          ></dcr-animated-kai>
          <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
            <div class="[ p-b-m ]">
              <polpo-register-form (register)="register($event)" [error]="registrationError$ | async"></polpo-register-form>
            </div>
          </div>
        }
      }
      <!-- Teacher registration -->
      @case ('teacher') {
        <h1 class="[ headline-large text-center ]" data-cy="form-header">Registreer als leerkracht</h1>
        @if (isMaintenanceMode$ | async) {
          <campus-maintenance-mode
            [statusPageUrl]="statusPageUrl"
          ></campus-maintenance-mode>
        } @else {
          <dcr-animated-kai
            #kai
            src="assets/rive/kai_state_machine.riv"
            autoplay
            track-lookat
            react-to-click
            class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
          ></dcr-animated-kai>
          @if (campaign$ | async; as campaign) {
            @if (campaign.key) {
              <h2 class="[ title-large text-center text-secondary ]">
                {{ campaign.title }}
              </h2>
            }
            <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
              <div class="[ p-b-m ]">
                @if (campaign.isExpired) {
                  <div class="[ corner-m p-i-m p-b-s error-container border border-error body-large ]">
                    Deze campagne is afgelopen.
                  </div>
                }
                @if (campaign.key && !campaign.isExpired) {
                  <polpo-register-teacher-form
                    (register)="registerTeacher($event, campaign.key)"
                    [error]="registrationError$ | async"
                  ></polpo-register-teacher-form>
                }
              </div>
            </div>
            @if (!campaign.key) {
              <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
                <div class="[ p-b-m ]">
                  <p class="[ body-large text-center text-secondary ]">Contacteer uw schoolbeheerder voor uw logingegevens van Polpo.</p>
                </div>
              </div>
            }
          }
        }
      }
    }
  }
</div>

@if (welcomeDialog$ | async; as welcomeDialog) {
  <dcr-dialog
    open
    [attr.headline]="welcomeDialog.headline"
    [attr.confirm-label]="welcomeDialog.confirmLabel"
    [attr.type]="welcomeDialog.confirmType"
    (confirm)="onWelcomeConfirm()"
    (cancel)="onWelcomeCancel()"
    >
    @if (welcomeDialog.existingEmail) {
      Je hebt reeds een account bij ons.
      <br />
      @if (welcomeDialog.campaign) {
        We hebben je toegevoegd aan de Keurieus school. Je krijgt op het platform alle Keurieus-producten te zien.
        <br />
      }
      <br />
      Meld je aan met dit e-mailadres:
      <strong>{{ welcomeDialog.existingEmail }}</strong>
    } @else {
      De registratie is voltooid.
      <br />
      We brengen je zo dadelijk naar het platform.
    }
  </dcr-dialog>
}
